<div class="container__login" *ngIf="!hideLogin">

  <section class="info">
    <img class="info__havrion-logo" src="../../../../assets/images/Havrion_Horiz.svg" alt="Havrion">
  </section>

  <section class="login">

    <div class="login__top">
      <img
        class="login__logo"
        src="../../../../assets/images/Havrion_H_Icon.svg"
      >

      <div class="login__buttons">
        <button
          class="btn login__btn"
          (click)="logInPressed('perform')">
          ACCESS NOW
        </button>
        <a
          (click)="newUser()"
          (keydown.enter)="newUser()"
          class="login__registration"
          tabindex="0"
          role="button"
        >
          New user?
        </a>
      </div>
    </div>

    <div class="login__swipper">
      <img
        src="../../../../assets/images/logo_perform.svg"
        alt="Perform">
    </div>
  </section>

<footer class="hh-footer">

  <div class="hh-footer__top">
    <div class="info-row">
      <span>
        2900 Monarch Lakes Blvd, Miramar, Florida 33027
      </span>
      <span>|</span>
      <a href="tel:+1-844-811-2486" style="color: #06c27d;">
        +1 844.811.2486
      </a>
      <span>|</span>
      <a [href]="contact" style="color: #06c27d;">
        Contact
      </a>
    </div>

  </div>

  <div class="hh-footer__bottom">
    <span>
      Copyright © {{ currentYear }} Havrion LLC All rights reserved
    </span>
    <span>|</span>
    <a href="/privacy-policy">
      Privacy Policy
    </a>
    <span>|</span>
    <a href="/terms-of-use">
      Terms of Use
    </a>
  </div>
</footer>

</div>
